import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

import Container from '../../components/Layout/Container';
import PageTopBanner from '../../components/PageTopBanner';

import { TabsLink } from '../../components/Tab/Tabs';
import { programData } from '../../components/Tab/TabData';

import Pagination from 'react-js-pagination';
import useScreenSize from '../../hooks/useScreenSize';

import Select from '../../components/Select/Select';
import Input, { onEnter } from '../../components/TextField/Input';

import { fetchGet } from '../../hooks/fetch';
import { ApplicationType, ApplyStatus, ProgramType } from './ProgramEnums';
import Loading from '../Loading';

export default function Program() {
	const [isLoading, setIsLoading] = useState(true);
	const [activeTab, setActiveTab] = useState('');
	const [searchParams, setSearchParams] = useSearchParams({ page: 1 });

	const handleDataFromChild = (data) => {
		setActiveTab(data);
	};

	const [posts, setPosts] = useState([]); // 현재 페이지 게시글 목록
	const [pagingInfo, setPagingInfo] = useState({});
	const [page, setPage] = useState(Number(searchParams.get("page")) ?? 1); // 현재 페이지 번호

	const [searchText, setSearchText] = useState(searchParams.get("searchText") ?? "");

	const postPerPage = 10; // 페이지 당 게시글 갯수

	const handlePageChange = (page) => {
		setPage(page);
	};

	const screenSize = useScreenSize();

	function getPage() {
		fetchGet(
			`/programs?page=${page}&searchText=${searchText}&programType=${selected}`,
			(json) => {
				setPosts(json.dataList);
				setPagingInfo(json.pagingInfo);
				setIsLoading(false);
			}
		)
	}

	const [selected, setSelected] = useState(searchParams.get("programType") ?? "ALL");
	const onKeyDown = (e) => onEnter(e, search);

	const search = () => {
		setSearchParams({
				page: page,
				searchText: searchText,
				programType: selected
			},
			{ replace: true }
		);
	}

	useEffect(() => {
		search();
		setIsLoading(true);
		getPage();
	}, [selected, searchText, page]);

	const pageName = '프로그램 신청';


	return (
		<main id="program-page-wrap">
			<h1 className="sr-only">{`${pageName} 페이지`}</h1>

			<PageTopBanner />

			<Container>
				<TabsLink
					className="sub-page-tab-con"
					tabsData={programData}
					activatedTab={activeTab}
					onTabChange={handleDataFromChild}
				/>

				<div className="page-content">
					<div className="content-top">
						<div>
							<h1 className="title">{pageName}</h1>
						</div>
					</div>

					<div>
						<div className="gs-total-search">
							<Select
								id="total-search-select"
								label="프로그램 종류를 선택해주세요."
								value={selected}
								onChange={(e) => { setSelected(e.target.value); setPage(1); }}
							>
								<option value={"ALL"}>전체</option>
								<option value={"ACADEMY"}>기술창업아카데미</option>
								<option value={"SUPPORT"}>창업기업 지원</option>
							</Select>
							<div className="search">
								<Input
									id="total-search-input"
									type="search"
									label="검색어를 입력해주세요."
									placeholder="검색어 입력"
									value={searchText}
									maxLength={15}
									onChange={(e) => { setSearchText(e.target.value); setPage(1); }}
									onKeyDown={onKeyDown}
								/>
								<button type="submit" onClick={search}>
									<span className="sr-only">검색하기</span>
								</button>
							</div>
						</div>
						
						<div className="gs-program-list">	
							{isLoading ?
								<Loading />
								:
								<ul>
									{posts?.length === 0 || posts === undefined ? (
										<li>
											<div className="gs-no-con">등록된 내용이 없습니다.</div>
										</li>
									) : (
										posts?.map((post, i) => (
											<li key={i}>
												<Link to={`/program/list/${post?.uid}`} state={{ page: page, searchText: searchText, programType: selected }}>
													<div className="thumb">
														<img src={`/api-tlo/file/image/${post.thumbnail}`} alt="" />
													</div>
													<div className="gs-infos-badge">
														<div className="info-1">
															<span className={`condition ${ApplicationType[post.applicationType]?.class}`}>
																{ApplicationType[post.applicationType]?.str}
																
															</span>
															<span className={`category ${ProgramType[post.programType]?.class}`}>
																{ProgramType[post.programType]?.str}
															</span>
															<span className={`state ${ApplyStatus[post.status]?.class}`}>
																{ApplyStatus[post.status]?.str}
															</span>
														</div>
														<div className="info-2">
															<h2>{post.title}</h2>
														</div>
														<div className="info-3">
															<div className="gs-unit pipeline gray">
																<span>신청기간 : {post.applyPeriod}</span>
																<span>
																	모집인원 : 
																	{post.recruitmentCount === 0
																		? ' 제한없음'
																		: ` ${post.recruitmentCount}명`}
																</span>
																<span>교육기간 : {post.educationPeriod}</span>
															</div>
														</div>
													</div>
												</Link>
											</li>
										))
									)}
								</ul>
							}
						</div>

						{posts?.length > 0 && (
							<Pagination
								innerClass="gs-pagination"
								// itemClass="pg-item"
								linkClass="btn"
								itemClassFirst="pg-arrow pg-first"
								itemClassPrev="pg-arrow pg-prev"
								itemClassNext="pg-arrow pg-next"
								itemClassLast="pg-arrow pg-last"
								firstPageText={null} // 첫 번째 페이지 탐색 버튼의 텍스트
								prevPageText={null} // 이전 페이지 탐색 버튼의 텍스트
								nextPageText={null} // 다음 페이지 탐색 버튼의 텍스트
								lastPageText={null} // 마지막 페이지 탐색 버튼의 텍스트
								activePage={page} // 현재 페이지
								totalItemsCount={pagingInfo.totalCount} // 총 아이템 갯수
								itemsCountPerPage={postPerPage} // 한 페이지랑 보여줄 아이템 갯수
								pageRangeDisplayed={screenSize.width >= 480 ? 5 : 3} // paginator의 페이지 범위 (useScreenSize custom hook 사용)
								onChange={handlePageChange} // 페이지 변경을 핸들링하는 함수
							/>
						)}
					</div>
				</div>
			</Container>
		</main>
	);
}
